import { Router } from "@angular/router";
import { ICategoriesWebServiceClient } from "@common/resources/resources";
import { Component } from "@angular/core";

@Component({
  selector: 'liste-categories',
  templateUrl: './liste.categories.component.html',
})
export class ListeCategoriesComponent {

  categories: any[];

  constructor(categoriesService: ICategoriesWebServiceClient, private router: Router) {
    categoriesService.rechercheCategories().subscribe(dto => {
      this.categories = dto;
    }, error => {
      this.categories = [];
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/categories/gestion-articles/liste-categories/liste.categories.component.ts